import React from 'react';
import { motion } from 'framer-motion';

import {
  Character,
  HandwritingAnswerCard,
  HandwritingAnswerCardData,
} from '../../Molecules';
import { AnswerCardStatus } from '../GameBlankAnswerCardsGroup';

import styles from './HandwritingGameAnswerCardsGroup.module.css';

type HandwritingGameAnswerCardsGroupProps = {
  character: Character | undefined;
  cardSize?: number;
  cards: HandwritingAnswerCardData[];
  onClickCard: (card: HandwritingAnswerCardData) => void;
  onUpdateCardStatus: (
    card: HandwritingAnswerCardData,
    newStatus: AnswerCardStatus,
  ) => void;
  tutorialCard?: HandwritingAnswerCardData;
};

export const HandwritingGameAnswerCardsGroup: React.FC<
  HandwritingGameAnswerCardsGroupProps
> = ({
  character,
  cardSize,
  cards,
  onClickCard,
  onUpdateCardStatus,
  tutorialCard,
}) => {
  return (
    <div className={styles.answerCardsGroup} style={{ minHeight: cardSize }}>
      {character &&
        cards.map((card, index) => (
          <motion.div
            key={index}
            className={styles.answerCardWrapper}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <HandwritingAnswerCard
              character={character}
              size={cardSize}
              card={card}
              onClick={() => onClickCard(card)}
              onUpdateCardStatus={onUpdateCardStatus}
              tutorialCard={tutorialCard}
            />
          </motion.div>
        ))}
    </div>
  );
};
